import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { open: Boolean }

  connect() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
    this.render()
  }

  openValueChanged() {
    this.render()
  }

  render() {
    this.element.classList.toggle("is-open", this.openValue)
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = !this.openValue
    }
  }
}
